import { authSlice } from './auth.reducer';

export const { SET_AUTH, SET_ACCOUNT, SET_INCIDENT_SETTINGS, SET_ACTIVE_GROUP, SET_ACTIVE_COUNTY } =
  authSlice.actions;
